module.exports = __webpack_public_path__ + "saira-regular-webfont.d6ff9da905932313a607.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/saira-regular-webfont.woff
// module chunks = styles